import Ebony71 from "../Ebony/Ebony 7.png"
import Ebony72 from "../Ebony/Ebony 7.png"

const Ebony7images =[
    Ebony71,Ebony72
]

export default Ebony7images;